var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAdd = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("g", {
  id: "add"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask0_0_181",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 20,
  height: 20
}, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  id: "Bounding box",
  width: 20,
  height: 20,
  fill: "#D9D9D9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_0_181)"
}, /*#__PURE__*/React.createElement("path", {
  id: "add_2",
  d: "M9.16667 10.8333H5C4.76389 10.8333 4.56597 10.7535 4.40625 10.5938C4.24653 10.434 4.16667 10.2361 4.16667 10C4.16667 9.76389 4.24653 9.56597 4.40625 9.40625C4.56597 9.24653 4.76389 9.16667 5 9.16667H9.16667V5C9.16667 4.76389 9.24653 4.56597 9.40625 4.40625C9.56597 4.24653 9.76389 4.16667 10 4.16667C10.2361 4.16667 10.434 4.24653 10.5938 4.40625C10.7535 4.56597 10.8333 4.76389 10.8333 5V9.16667H15C15.2361 9.16667 15.434 9.24653 15.5938 9.40625C15.7535 9.56597 15.8333 9.76389 15.8333 10C15.8333 10.2361 15.7535 10.434 15.5938 10.5938C15.434 10.7535 15.2361 10.8333 15 10.8333H10.8333V15C10.8333 15.2361 10.7535 15.434 10.5938 15.5938C10.434 15.7535 10.2361 15.8333 10 15.8333C9.76389 15.8333 9.56597 15.7535 9.40625 15.5938C9.24653 15.434 9.16667 15.2361 9.16667 15V10.8333Z",
  fill: "#1C1B1F"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add.c5e5b262cc5530875521c66c0c220234.svg";